import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type ToastProps = {
  message: string;
  onClose: () => void;
  type?: "success" | "error";
};

export function ToastNotifier({ message, onClose, type = "error"  }: ToastProps) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onClose(); // notify parent
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = () => {
    setShow(false);
    onClose(); // notify parent
  };

  if (!show) return null;

  const backgroundClass = type === "success" ? "bg-success" : "bg-danger";

  return createPortal(
    <div className="toast-container position-fixed top-0 end-0 p-3" style={{ zIndex: 1055 }}>
      <div className={`toast show align-items-center text-white ${backgroundClass} border-0`} role="alert">
        <div className="d-flex">
          <div className="toast-body">
            {message}
          </div>
          <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => handleClose()} />
        </div>
      </div>
    </div>,
    document.body
  );
}
